import styled from "styled-components";

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		padding: 0 1em;
		width: 100%;
		min-height: 162px;
		background-image: url(${(props) => props.image});
		background-size: cover;

		button {
			background: none;
			border: none;
			margin-top: 10px;
			margin-bottom: 5px;
			padding: 0;
		}

		h1 {
			font-family: "PFSquareSansProBold", sans-serif;
			font-size: 2.625em;
			color: var(--white);
			margin-top: 0px;

			span {
				display: block;
				font-family: "PFSquareSansProMedium", sans-serif;
				font-size: 1.125rem;
				color: var(--white);
			}
		}
	}

	@media screen and (min-width: 992px) {
		min-height: 260px;
		display: flex;
		align-items: center;
		justify-content: center;

		button {
			display: none;
		}

		h1 {
			font-size: 3.75em;
			text-align: center;
			margin-bottom: 0;

			span {
				font-size: 0.4em;
			}
		}
	}
`;
